import React from 'react';
import PropTypes from 'prop-types';
import InfoBanner from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/InfoBanner';
import {
    ExpandableReviewRow,
    ReviewRow,
} from '@/features/datasets/components/DataCollection/GenerateDataWithAI/shared/ReviewRows';
import { COST_BANNER_TEXT } from '@/features/datasets/components/DataCollection/GenerateDataWithAI/constants';

export const REVIEW_DESCRIPTION =
    'Confirm the configuration below. Generation will run asynchronously and notify you on completion.';

/**
 * Final "Review & Generate" step shared by every Generate-with-AI flow:
 * third-party charges warning, then a read-only summary of the configuration
 * (mirrors the Retrieval Agent's Review & Initiate step).
 */
const ReviewStep = ({ goal, customGuidelines, languages, taskTypeLabel, totalRecords }) => (
    <>
        <InfoBanner text={COST_BANNER_TEXT} />
        <div className="gdai-section">
            <div className="gdai-section-heading fs-unmask">Review & Generate</div>
            <p className="gdai-field-hint fs-unmask">{REVIEW_DESCRIPTION}</p>
            <ReviewRow label="Goal" value={goal} alignValueLeft />
            <ExpandableReviewRow label="Description" value={customGuidelines} />
            <ReviewRow label="Languages" value={(languages || []).join(', ')} />
            <ReviewRow label="Task Type" value={taskTypeLabel} />
            <ReviewRow
                label="Total records"
                value={
                    Number.isFinite(totalRecords)
                        ? `${totalRecords.toLocaleString('en-US')} records`
                        : null
                }
            />
        </div>
    </>
);

ReviewStep.propTypes = {
    goal: PropTypes.string,
    customGuidelines: PropTypes.string,
    languages: PropTypes.arrayOf(PropTypes.string),
    taskTypeLabel: PropTypes.string,
    totalRecords: PropTypes.number,
};

export default ReviewStep;
